import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

const Dashboard = () => {
  const [totalPoints, setTotalPoints] = useState(0);
  const [totalSpins, setTotalSpins] = useState(0);
  const [totalWins, setTotalWins] = useState(0);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    // Read from localStorage
    const points = parseInt(Cookies.get("point") || '5000', 10);
    const spins = parseInt(localStorage.getItem('totalSpins') || '0', 10);
    const wins = parseInt(localStorage.getItem('totalWins') || '0', 10);
    const hist = JSON.parse(localStorage.getItem('spinHistory') || '[]');

    setTotalPoints(points);
    setTotalSpins(spins);
    setTotalWins(wins);
    setHistory(hist);
  }, []);

  return (
    <div className="min-h-screen bg-[#110D15] text-white p-6 md:p-12 font-sans overflow-y-auto">
      <div className="max-w-6xl mx-auto">
        {/* Back Button */}
        <Link 
          to="/game" 
          className="inline-flex items-center text-gray-400 hover:text-white transition-colors mb-8 group"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5 mr-2 transform group-hover:-translate-x-1 transition-transform" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor" 
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          Back to Game
        </Link>

        {/* Dashboard Title */}
        <h1 className="text-3xl md:text-4xl font-black tracking-wide mb-10">
          Dashboard
        </h1>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          
          {/* Total Points Card */}
          <div className="bg-[#1C1823] border border-white/5 rounded-2xl p-6 flex items-center gap-6 shadow-lg shadow-black/20">
            <div className="w-16 h-16 rounded-xl bg-purple-900/40 flex items-center justify-center border border-purple-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 18.75h-9m9 0a3 3 0 013 3h-15a3 3 0 013-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 01-.982-3.172M9.497 14.25a7.454 7.454 0 00.981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 007.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 002.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 012.916.52 6.003 6.003 0 01-5.395 4.972m0 0a6.726 6.726 0 01-2.749 1.35m0 0a6.772 6.772 0 01-3.044 0" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-400 mb-1">Total Points</p>
              <h2 className="text-3xl font-bold tracking-wider">{totalPoints.toLocaleString()}</h2>
            </div>
          </div>

          {/* Total Spins Card */}
          <div className="bg-[#1C1823] border border-white/5 rounded-2xl p-6 flex items-center gap-6 shadow-lg shadow-black/20">
            <div className="w-16 h-16 rounded-xl bg-blue-900/40 flex items-center justify-center border border-blue-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 13h4.51l2.67-8.01a.75.75 0 011.42.13l2.74 13.7 2.1-6.3a.75.75 0 011.42 0l1.64 4.93H21" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-400 mb-1">Total Spins</p>
              <h2 className="text-3xl font-bold tracking-wider">{totalSpins.toLocaleString()}</h2>
            </div>
          </div>

          {/* Total Wins Card */}
          <div className="bg-[#1C1823] border border-white/5 rounded-2xl p-6 flex items-center gap-6 shadow-lg shadow-black/20">
            <div className="w-16 h-16 rounded-xl bg-green-900/40 flex items-center justify-center border border-green-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zm-7.518-.267A8.25 8.25 0 1120.25 10.5M8.288 14.212A5.25 5.25 0 1117.25 10.5" />
              </svg>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-400 mb-1">Total Wins</p>
              <h2 className="text-3xl font-bold tracking-wider">{totalWins.toLocaleString()}</h2>
            </div>
          </div>

        </div>

        {/* Recent Spin History */}
        <h3 className="text-xl font-bold mb-6 tracking-wide">Recent Spin History</h3>
        
        <div className="bg-[#1C1823] border border-white/5 rounded-2xl overflow-hidden shadow-lg shadow-black/20">
          <div className="grid grid-cols-3 p-4 bg-white/5 font-semibold text-sm text-gray-300">
            <div>Date</div>
            <div className="text-center">Reward</div>
            <div className="text-right">Points</div>
          </div>
          
          <div className="divide-y divide-white/5">
            {history.length === 0 ? (
              <div className="p-8 text-center text-gray-500 font-medium">
                No spins yet. Go play the game!
              </div>
            ) : (
              history.map((item, idx) => (
                <div key={idx} className="grid grid-cols-3 p-4 text-sm items-center hover:bg-white/[0.02] transition-colors">
                  <div className="text-gray-400">{item.date}</div>
                  <div className="text-center font-medium">{item.reward}</div>
                  <div className={`text-right font-bold ${item.points === '0' ? 'text-gray-500' : 'text-yellow-500'}`}>
                    {item.points}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
